import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const CommsSelect = ({
                         value = '',
                         onChange = () => {},
                         readonly = false,
                         placeholder = 'Select Comms type...',
                         className = ''
                     }) => {
    const [isOpen, setIsOpen] = useState(false);

    const commOptions = [
        { value: 'GMRS', label: 'GMRS' },
        { value: 'FRS', label: 'FRS' },
        { value: 'HAM', label: 'HAM' },
        { value: 'CB', label: 'CB' },
        { value: 'Other', label: 'Other' }
    ];

    const selectedOption = commOptions.find(option => option.value === value);

    const handleSelect = (optionValue) => {
        if (!readonly) {
            onChange(optionValue);
            setIsOpen(false);
        }
    };

    const toggleDropdown = () => {
        if (!readonly) {
            setIsOpen(!isOpen);
        }
    };

    return (
        <div className={`relative ${className}`}>
            <label className="block text-sm font-bold text-gray-700 mb-1">
                Comms
            </label>

            <div className="relative">
                <button
                    type="button"
                    onClick={toggleDropdown}
                    disabled={readonly}
                    className={`
            w-full px-3 py-2 text-left bg-white border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
            ${readonly
                        ? 'bg-gray-50 text-gray-500 cursor-not-allowed border-gray-200'
                        : 'border-gray-300 hover:border-gray-400 cursor-pointer'
                    }
            ${isOpen && !readonly ? 'ring-2 ring-blue-500 border-blue-500' : ''}
          `}
                >
          <span className={selectedOption ? 'text-gray-900' : 'text-gray-400'}>
            {selectedOption ? selectedOption.label : placeholder}
          </span>
                    <ChevronDown
                        className={`
              absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 transition-transform
              ${readonly ? 'text-gray-400' : 'text-gray-500'}
              ${isOpen && !readonly ? 'rotate-180' : ''}
            `}
                    />
                </button>

                {isOpen && !readonly && (
                    <>
                        {/* Backdrop */}
                        <div
                            className="fixed inset-0 z-10"
                            onClick={() => setIsOpen(false)}
                        />

                        {/* Dropdown */}
                        <div className="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                            {commOptions.map((option) => (
                                <button
                                    key={option.value}
                                    type="button"
                                    onClick={() => handleSelect(option.value)}
                                    className={`
                    w-full px-3 py-2 text-left hover:bg-blue-50 focus:bg-blue-50 focus:outline-none
                    ${value === option.value ? 'bg-blue-100 text-blue-900' : 'text-gray-900'}
                  `}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </>
                )}
            </div>

            {readonly && (
                <p className="mt-1 text-xs text-gray-500">
                    Read-only mode
                </p>
            )}
        </div>
    );
};

export default CommsSelect;